var exports = {
  "k": "xdbfd91f1--94f8af--checkbox",
  "U": "xdbfd91f1--94f8af--checkbox--active",
};

module.exports = exports;
